import { Option } from 'funfix-core';
import React from 'react';
import { ANALYTICS_MODAL_SHOW_TOKEN } from '../../../../../analytics/Sources';
import { getErrorDetails } from '../../../../../utils/request-utils';
import DialogShowAppSpecificPasswordContent from './DialogShowAppSpecificPasswordContent';
import DialogShowAppSpecificPasswordFooter from './DialogShowAppSpecificPasswordFooter';
import foldShowAppSpecificPasswordInstallStatus from './foldShowAppSpecificPasswordInstallStatus';
const resolveDialogShowAppSpecificPassword = _ref => {
  let {
    closeInstallDialog,
    context,
    hostConfig,
    installStatus,
    name,
    featureFlags
  } = _ref;
  return {
    analyticsSourceModal: ANALYTICS_MODAL_SHOW_TOKEN,
    content: /*#__PURE__*/React.createElement(DialogShowAppSpecificPasswordContent, {
      context: context,
      installStatus: installStatus,
      tokenConfig: hostConfig.token
    }),
    heading: "".concat(name, " token"),
    footerRight: foldShowAppSpecificPasswordInstallStatus(installStatus, () => null, () => /*#__PURE__*/React.createElement(DialogShowAppSpecificPasswordFooter, {
      closeInstallDialog: closeInstallDialog
    })),
    preventDialogClosing: foldShowAppSpecificPasswordInstallStatus(installStatus, () => true, () => false),
    errorDetails: foldShowAppSpecificPasswordInstallStatus(installStatus, () => Option.empty(), complete => complete.result.fold(error => Option.some(getErrorDetails(error, hostConfig, {
      showCustomBackendErrorsFromUpm: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.showCustomBackendErrorsFromUpm
    })), () => Option.empty()))
  };
};
export default resolveDialogShowAppSpecificPassword;